<template>
  <Header />
  <div class="swiper-container">
    <swiper
      :modules="modules"
      :slides-per-view="1"
      :space-between="10"
      navigation
      :pagination="{ clickable: true }"
      :autoplay="{ delay: 5000 }"
      loop
    >
      <!-- Her resmi bir slide olarak ekle -->
      <swiper-slide v-for="(item, index) in items" :key="index">
        <img :src="item.src" alt="Slide Image" />
      </swiper-slide>
    </swiper>
  </div>
  <div class="ortala">
    <div class="collection-banner">
      <div class="banner" v-for="(item, index) in banner" :key="index">
        <img :src="item.src" alt="" />
      </div>
    </div>
  </div>
  <div class="parallax"></div>
  <div class="ortala">
    <div class="projects-container">
      <div class="projects-title">
        <h1>Projelerimiz</h1>
        <p>Hayal gücünüzü gerçeğe dönüştüren projelerimizle tanışın!</p>
      </div>
      <div class="projects-button">
        <router-link to="/projeler">Projelerimize Göz Atın</router-link>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
// Swiper core and required modules
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";

export default {
  name: "HomeView",
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      items: [
        {
          src: require("@/assets/img/col3.jpg"),
        },
        {
          src: require("@/assets/img/img2.jpg"),
        },
        {
          src: require("@/assets/img/banner.jpg"),
        },
      ],
      banner: [
        {
          src: require("@/assets/img/col1.jpg"),
        },
        {
          src: require("@/assets/img/col2.jpg"),
        },
        {
          src: require("@/assets/img/img1.jpg"),
        },
      ],
    };
  },
  setup() {
    return {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
    };
  },
  mounted() {
    document.title = "Ayyıldız Mobilya";
    window.scrollTo({ top: 0, behavior: "smooth" }); // Sayfanın üstüne kaydır
  },
};
</script>
<style>
.swiper-container {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.swiper-slide img {
  width: 100%;
  height: 800px;
}
/* Telefon görünümü için */
@media (max-width: 768px) {

  .swiper-slide img {
    height: 400px;
  }

  /* Navigasyon butonları */
  .swiper-button-next,
  .swiper-button-prev {
    color: #007bff; /* Butonları mavi renkle öne çıkar */
    font-size: 18px; /* Mobil için boyut küçült */
    opacity: 0.8; /* Daha şeffaf görünüm */
    transition: opacity 0.3s ease;
  }

  .swiper-button-next:hover,
  .swiper-button-prev:hover {
    opacity: 1; /* Hover sırasında butonları belirgin yap */
  }

  /* Pagination (Alt noktalar) */
  .swiper-pagination-bullets {
    bottom: 15px !important; /* Noktaları biraz yukarı al */
  }

  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    margin: 0 5px;
    opacity: 0.8;
    transition: transform 0.3s ease, opacity 0.3s ease;
  }

  .swiper-pagination-bullet-active {
    transform: scale(1.2); /* Aktif noktayı büyüt */
    opacity: 1; /* Aktif noktanın belirginliğini artır */
  }
}
.collection-banner {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 eşit sütun */
  gap: 30px; /* Resimler arasındaki boşluk */
  width: auto;
  margin: 50px auto; /* Ortalamak için margin */
}

.collection-banner .banner {
  overflow: hidden;
}

.collection-banner .banner img {
  width: 100%; /* Görsellerin sütuna tam oturması */
  height: auto; /* Oranını koruması */
  transition: transform 0.3s ease-in-out; /* Hover animasyonu için */
}

.collection-banner .banner img:hover {
  transform: scale(1.05); /* Hover'da görselleri büyüt */
}
@media (max-width: 768px) {
  .collection-banner {
    grid-template-columns: 1fr; /* Tek sütun */
  }
}

.parallax {
  width: 100%;
  height: 600px;
  background-image: url("@/assets/img/img3.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.projects-container {
  display: flex;
  align-items: center; /* Dikey ortalama */
  justify-content: space-between; /* Sol ve sağ içerikleri ayırma */
  width: auto;
  max-width: 1200px;
  margin: 50px auto; /* Ortalamak için margin */
  background: linear-gradient(
    145deg,
    #f3f4f6,
    #e3e4e6
  ); /* Hafif bir degrade arka plan */
  padding: 20px 30px;
  border-radius: 15px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.projects-title {
  flex: 2; /* Daha geniş alan */
}

.projects-title h1 {
  font-size: 36px;
  font-weight: bold;
  margin: 0 0 10px;
  color: #333; /* Yazı rengi */
}

.projects-title p {
  font-size: 18px;
  color: #555;
}

.projects-button {
  flex: 1; /* Daha dar alan */
  display: flex;
  justify-content: flex-end; /* Butonu sağa yaslama */
  align-items: center;
}

.projects-button a {
  text-decoration: none;
  font-size: 18px;
  font-weight: bold;
  color: white;
  background: #007bff; /* Mavi bir renk */
  padding: 12px 25px;
  border-radius: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 123, 255, 0.3);
}

.projects-button a:hover {
  background: #0056b3; /* Daha koyu bir mavi */
  transform: translateY(-3px); /* Hover sırasında hafif yukarı hareket */
  box-shadow: 0 8px 20px rgba(0, 123, 255, 0.5);
}

@media (max-width: 768px) {
  .projects-container {
    flex-direction: column; /* Mobilde içerikleri alt alta diz */
    text-align: center; /* İçerikleri ortala */
  }

  .projects-title {
    margin-bottom: 20px;
  }

  .projects-button {
    justify-content: center;
  }
}
</style>
